
import {
  ChangeDetectionStrategy,
  Component,
  EventEmitter,
  HostBinding,
  HostListener,
  Input,
  Output,
} from '@angular/core'
import { TypographyComponent } from '../typography/typography.component'

@Component({
  selector: 'hyperkit-dropdown-menu-item',
  templateUrl: './dropdown-menu-item.component.html',
  styleUrls: ['./dropdown-menu-item.component.scss'],
  standalone: true,
  imports: [TypographyComponent],
  changeDetection: ChangeDetectionStrategy.OnPush,
})
export class DropdownMenuItemComponent {
  @Input() value: any
  @Input() disabled = false
  @Input() selected = false
  @Input() label?: string
  @Output() itemClick = new EventEmitter<any>()

  @HostBinding('class.disabled') get isDisabled() {
    return this.disabled
  }
  @HostBinding('class.selected') get isSelected() {
    return this.selected
  }
  @HostBinding('attr.tabindex') tabindex = 0
  @HostBinding('class.focused') isFocused = false

  @HostListener('click', ['$event'])
  onClick(event: MouseEvent) {
    if (!this.disabled) {
      this.itemClick.emit({
        value: this.value,
        originalEvent: event,
      })
    }
  }

  @HostListener('focus')
  onFocus() {
    this.isFocused = true
  }

  @HostListener('blur')
  onBlur() {
    this.isFocused = false
  }

  @HostListener('keydown.enter', ['$event'])
  onEnter(event: Event) {
    if (!this.disabled) {
      this.itemClick.emit({
        value: this.value,
        originalEvent: event,
      })
    }
  }
}
